"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { WorkspaceElementType } from '@integration-app/sdk';
import { useElement } from '../useElement.mjs';

function useAppDataSchema(selector) {
  const { item: appDataSchema, ...rest } = useElement(
    WorkspaceElementType.AppDataSchema,
    selector,
    (integrationApp) => selector ? integrationApp.appDataSchema(selector) : void 0
  );
  return { appDataSchema, ...rest };
}

export { useAppDataSchema };
